import { fromEvent, Subject } from 'rxjs';

import { useRootInstance } from './useRootInstance';

export const useSocket = () => {
  const root = useRootInstance();

  const socket = root.$socket as {
    on: (event: string, callback: Function) => void;
    emit: (event: string, ...data: any[]) => void;
    off: (event: string, callback: Function) => void;
  };

  const socketProxy = {
    on: (event: string, callback: Function) => socket.on(event, callback),
    off: (event: string, callback: Function) => socket.off(event, callback)
  };

  return {
    on$: <T>(event: string) => fromEvent<T>(socketProxy, event),
    emit: (event: string, ...data: any[]) => socket.emit(event, ...data)
  };
};
